import { useEffect, useEffectEvent } from "react";
import { useSessionActivity } from "./SessionActivityContext";

const HEARTBEAT_INTERVAL_MS = 30_000;

/**
 * Keeps the cross-tab idle timer alive while a long-running media process
 * (e.g. VOD or live playback) is active, even without further UI interaction.
 */
export const useMediaActivityHeartbeat = (isPlaying: boolean) => {
    const { heartbeat, isEnabled } = useSessionActivity();
    const sendHeartbeat = useEffectEvent(() => heartbeat());

    useEffect(() => {
        if (!isPlaying || !isEnabled) {
            return;
        }

        sendHeartbeat();
        const interval = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL_MS);
        return () => clearInterval(interval);
    }, [isPlaying, isEnabled]);
};
